import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppProvider as PolarisAppProvider } from '@shopify/polaris';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import enTranslations from '@shopify/polaris/locales/en.json';
import '@shopify/polaris/build/esm/styles.css';
import { App } from './App';
import { ApiProvider } from './shared/api/ApiContext';
import { RouterLink } from './shared/components/RouterLink';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('No #root element');

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <PolarisAppProvider i18n={enTranslations} linkComponent={RouterLink}>
        <QueryClientProvider client={queryClient}>
          <ApiProvider>
            <App />
          </ApiProvider>
        </QueryClientProvider>
      </PolarisAppProvider>
    </BrowserRouter>
  </StrictMode>,
);
